export class PlacemarksFields {
  PrimaryFields: string[];
  TableKeys?: string[];
}
